<template>
  <app-data-editor
    :id="id"
    title="Редактирование производителя"
    resource="manufacturers"
    :elements="elements"
    add-message="Производитель добавлен"
    edit-message="Производитель изменен"
    @change="payload => (isChanged = payload)"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                v => !!v || "Наименование обязательно к заполнению",
                v => {
                  const pattern = /[^,\s."']/g;
                  return (
                    pattern.test(v.charAt(0)) ||
                    v === "" ||
                    "Наименование не может начинаться c пробела, кавычек, точки или запятой"
                  );
                },
              ],
              isHideDetails: false,
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
